import * as actions from './actions'

const getRoot = state => state.experiment

const getStatus = state => getRoot(state).status

export const getLoaded = state => {
  return [actions.setLoaded.toString(), actions.timedOut.toString()].includes(getStatus(state))
}
export const getLoading = state => getStatus(state) === actions.setPending()



// WEBPACK FOOTER //
// ./src/modules/experiment/selectors.js